export const environment = {
    production: false,
    recaptcha: {
        siteKey: '6Lf_pJgjAAAAAESYRqiAbKpFLgsezYqgFxhktdXn',
    },
    appInsightsInstrumentationKey: '5e01375b-fee1-491f-9b38-ba52334bf250',
    baseUrl: "https://webapi-ir-contest-dev-cus-01.azurewebsites.net",
    googleMapApiKey: "AIzaSyAiMGzXgD4l9LyL4Ay-mOdA_ZGoWYWIvAs",
};
